import script from "./PersonalCenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalCenter.vue?vue&type=script&setup=true&lang=ts"

import "../style/PersonalCenter.css?vue&type=style&index=0&id=82d7f0f8&scoped=true&lang=css&external"
import "./PersonalCenter.vue?vue&type=style&index=1&id=82d7f0f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82d7f0f8"]])

export default __exports__